/**
 * Route copy for `src/routes/staffQuestions` (keys: `routes.staffQuestions.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  questionCard: {
    reservedForTheOrganizationSOwner: 'Reserved for the organization\'s owner or an administrator.',
    answerSavedTheTaskWillResume: 'Answer saved — the task will resume as soon as the resource is freed.',
    answerSentTheTaskIsResuming: 'Answer sent — the task is resuming.',
    sendingTheAnswerFailedTryAgain: 'Sending the answer failed. Try again.',
    agentThatAskedTheQuestion: 'Agent that asked the question',
    theAgentSuggestsQuickAnswers: 'The agent suggests quick answers',
    option: 'option',
    askedV: 'Asked {{v}}',
    taskTitle: 'Task: {{title}}',
    task: 'Task:',
    run: 'Run:',
    plan: 'Plan:',
    hideTheContext: 'Hide the context',
    viewTheContextProvidedByThe: 'View the context provided by the agent',
    suggestedAnswers: 'Suggested answers',
    yourReply: 'Your reply',
    ctrlEnterToSend: 'Ctrl+Enter to send.',
    answerTheAgentToResumeThe: 'Answer the agent to resume the task…',
    sending: 'Sending…',
    answerAndResumeTheTask: 'Answer and resume the task',
  },
  questionsInboxPage: {
    tooManyRequestsLimitTemporarilyReached: 'Too many requests — limit temporarily reached. Wait a moment, then try again.',
    serviceTemporarilyUnavailableCheckYourCo: 'Service temporarily unavailable. Check your connection and try again.',
    couldNotLoadThePendingQuestions: 'Could not load the pending questions.',
    questionsAskedByYourAiAgents: 'Questions asked by your AI agents awaiting a human answer to resume their task.',
    baseRefreshedAutomaticallyEveryVS: '{{base}} Refreshed automatically every {{v}} s.',
    agentQuestions: 'Agent questions',
    nonePending: 'None pending',
    lengthPending: '{{length}} pending',
    refreshing: 'Refreshing…',
    refresh: 'Refresh',
    ownerOrAdministratorRoleRequiredTo: 'Owner or administrator role required to answer an agent. You can view the questions read-only.',
    loadingQuestions: 'Loading questions…',
    noPendingQuestion: 'No pending question',
    whenAnAgentNeedsAHuman: 'When an agent needs a human decision to continue, the question appears here and its task stays paused until you answer.',
  },
};

export default en;
